import { datalayerInstance } from '../../';
import categoryPageAttributes from '../../category-page-attributes';
import { AppProps } from 'src/app/App';

export enum TEST_COE_TYPES {
  SWATCH_INTERACTION_ICON = 'Category_ColorSwatch',
  SWATCH_INTERACTION_ARROW = 'Category_ColorArrow',
}

interface buildColorSwatchesDataLayerTypes {
  onFirstColorSwatchClick: () => void;
  onFirstCarouselArrowClick: () => void;
}

export const buildColorSwatchesDataLayer = (
  props: AppProps
): buildColorSwatchesDataLayerTypes => {
  const callDatalayerLink = (test_coe: TEST_COE_TYPES) => {
    try {
      datalayerInstance().link({
        test_coe,
        ...categoryPageAttributes(props),
      });
    } catch (err) {
      datalayerInstance().link({
        business_unit_id: props.businessUnitId,
        error_message: `[Category Color Swatch Data Layer]: error: ${err.message}`,
      });
    }
  };

  return {
    onFirstColorSwatchClick: () => {
      callDatalayerLink(TEST_COE_TYPES.SWATCH_INTERACTION_ICON);
    },
    onFirstCarouselArrowClick: () => {
      callDatalayerLink(TEST_COE_TYPES.SWATCH_INTERACTION_ARROW);
    },
  };
};
